import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/client/lib/api";
import type { MyInvitation } from "@/features/identity/schemas";

export const invitationsQuery = queryOptions({
  queryKey: ["me", "invitations"],
  queryFn: (): Promise<MyInvitation[]> =>
    unwrap(api.me.invitations.$get()).then(({ items }) => items),
});
